import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './theme/theme.css'; // Variáveis CSS do tema global
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Importar ferramentas de diagnóstico de autenticação
import '../src/utils/authDiagnostics';

// Importar e aplicar cores do tema via variáveis de ambiente
import applyThemeColors from './theme/applyTheme';

// Aplicar cores do tema no carregamento da aplicação
applyThemeColors();

// Suprimir erro do ResizeObserver do ReactFlow
const resizeObserverErr = window.console.error;
window.console.error = (...args: any[]) => {
  if (typeof args[0] === 'string' && args[0].includes('ResizeObserver loop')) {
    return;
  }
  resizeObserverErr(...args);
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Registrar Service Worker para PWA com notificacoes
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('[SW] App pronto para uso offline');
  },
  onUpdate: (registration) => {
    console.log('[SW] Nova versao disponivel');
    // Atualizar automaticamente para a versao mais recente
    const waitingWorker = registration.waiting;
    if (waitingWorker) {
      waitingWorker.postMessage({ type: 'SKIP_WAITING' });
      waitingWorker.addEventListener('statechange', () => {
        if (waitingWorker.state === 'activated') {
          window.location.reload();
        }
      });
    }
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
